import { inRange, isNil, max, min } from 'lodash';
import { type } from '@mews-framework/utils';
import { IntervalType } from './types';

const EMPTY_INTERVAL = Interval();

function Interval({ high = null, low = null }: $TSFixMe = {}): IntervalType {
    const start = min([high, low]);
    const end = max([high, low]);
    return type.create(Interval, { high: end, low: start });
}

function is(interval: IntervalType) {
    type.check(interval, Interval);
}

function isEmpty(interval: $TSFixMe) {
    is(interval);
    return isNil(interval.high) || isNil(interval.low);
}

function isEqual(a: $TSFixMe, b: $TSFixMe) {
    is(a);
    is(b);

    return a.high === b.high && a.low === b.low;
}

/**
 * Is B contained in A
 */
function contains(a: $TSFixMe, b: $TSFixMe) {
    is(a);
    is(b);

    return inRange(b.high, a.low, a.high) && inRange(b.low, a.low, a.high);
}

function collides(a: $TSFixMe, b: $TSFixMe) {
    is(a);
    is(b);

    return (
        inRange(a.high, b.low, b.high) ||
        inRange(a.low, b.low, b.high) ||
        inRange(b.high, a.low, a.high) ||
        inRange(b.low, a.low, a.high)
    );
}

function union(a: $TSFixMe, b: $TSFixMe) {
    if (!collides(a, b)) {
        return EMPTY_INTERVAL;
    }

    const high = max([a.high, b.high]);
    const low = min([a.low, b.low]);

    return Interval({ high, low });
}

/**
 * Returns set of intervals created by difference.
 * Difference is made in order of subtracting B from A.
 */
function difference(a: IntervalType, b: IntervalType) {
    const intervalIntersection = intersection(a, b);

    if (isEmpty(intervalIntersection)) {
        return [a];
    }

    if (isEqual(a, intervalIntersection)) {
        return [EMPTY_INTERVAL];
    }

    if (contains(a, b)) {
        return [Interval({ high: b.low, low: a.low }), Interval({ high: a.high, low: b.high })];
    }

    if (a.high > b.high) {
        return [Interval({ high: a.high, low: b.high })];
    }

    return [Interval({ high: b.low, low: a.low })];
}

function intersection(a: $TSFixMe, b: $TSFixMe) {
    if (!collides(a, b)) {
        return EMPTY_INTERVAL;
    }

    const high = min([a.high, b.high]);
    const low = max([a.low, b.low]);

    return Interval({ high, low });
}

export default {
    create: Interval,
    is,
    isEmpty,
    isEqual,
    contains,
    collides,
    union,
    difference,
    intersection,

    Empty: EMPTY_INTERVAL,
};
